import React, { PropTypes } from 'react'
import classnames from 'classnames'

const BOTTOM_MARGIN = 6

export default function FieldError({ error, on, position }) {
    if (! error || error.length === 0) {
        return null
    }

    const errorClasses = classnames({
        'form__error': true,
        'form__error--tooltip': true,
        'form__error--tooltip-on': on,
    })

    const errorStyle = { whiteSpace: 'pre-wrap' }

    if (position) {
        errorStyle.bottom = position + BOTTOM_MARGIN
    }

    return (
        <div className={ errorClasses } style={ errorStyle }>
            { do {
                if (error.length === 1) {
                    error[0]
                } else {
                    <ul>
                        { error.map((error, index) => <li key={ index }>{ error }</li>) }
                    </ul>
                }
            } }
        </div>
    )
}

FieldError.propTypes = {
    error: PropTypes.array,
    on: PropTypes.bool,
    position: PropTypes.number,
}

FieldError.defaultProps = {
    error: [],
    on: false,
    position: 0,
}



// WEBPACK FOOTER //
// ./app/components/ui/fielderror.js